import React, { useEffect } from 'react'
import Hero from './components/Hero'
import TrustBar from './components/TrustBar'
import Problem from './components/Problem'
import Solution from './components/Solution'
import HowItWorks from './components/HowItWorks'
import Features from './components/Features'
import SocialProof from './components/SocialProof'
import Pricing from './components/Pricing'
import FAQ from './components/FAQ'
import FinalCTA from './components/FinalCTA'
import Footer from './components/Footer'

function App() {
  useEffect(() => {
    // Animate elements on scroll
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible')
          }
        })
      },
      { threshold: 0.1 }
    )

    const animatedElements = document.querySelectorAll('.animate-on-scroll')
    animatedElements.forEach((el) => observer.observe(el))

    return () => observer.disconnect()
  }, [])

  // Analytics tracking
  const trackEvent = (eventName, properties = {}) => {
    if (window.gtag) {
      window.gtag('event', eventName, properties)
    }
    if (window.mixpanel) {
      window.mixpanel.track(eventName, properties)
    }
    console.log('Event tracked:', eventName, properties)
  }

  return (
    <div className="App">
      <Hero trackEvent={trackEvent} />
      <TrustBar />
      <Problem />
      <Solution />
      <HowItWorks trackEvent={trackEvent} />
      <Features />
      <SocialProof />
      <Pricing trackEvent={trackEvent} />
      <FAQ />
      <FinalCTA trackEvent={trackEvent} />
      <Footer />
    </div>
  )
}

export default App
